import React, {useState, useEffect} from 'react';
import { Link } from "react-router-dom";
import ofertasServices from '../services/ofertasServices';
import { errorClassification } from '../errorHandler';

const Home = () => {
  const [tiposOfertas, setTiposOfertas] = useState({});

  const fetchTiposOfertas = async () => {
    try {
      const data = await ofertasServices.tiposOfertas();
      setTiposOfertas(data)
    } catch (error) {
      const result = errorClassification(error)
      if(result.modal){
        alert(result.message)
      }
    }
  };

  useEffect(() => {
    fetchTiposOfertas()
  }, []);

  return (
    <div className='text-center'>
        <div className="row w-75 m-auto">
            {Object.keys(tiposOfertas).map((tipo, idx) => (
              <div key={idx} className="col-sm-6 d-grid">
              <Link
                className="btn btn-success bg-gradient py-5 mb-3 fs-3"
                to={`/concursos/${tipo}`}
                >{tiposOfertas[tipo]}</Link>
              </div>
            ))}

            {/* <Link className="dropdown-item px-1 py-1" to="/listaOfertas">Listar Concursos</Link> */}

        </div>

    </div>
  );
};

export default Home;